module.exports = __webpack_public_path__ + "img/american express.e3716c3e.png";